import apis, { inventoryOrders } from "@/apis/requirement";
import useDataDetail from "@/hooks/useDataDetail";
import { Requirement, RequirementItem, RequirementItemDelEnum } from "@/types/requirement";
import { Dispatch, SetStateAction, useState } from "react";
import dayjs from "dayjs";
import { dateFormat } from "@/utils/format";
import { InventoryOrdersItem } from "@/types/purchase";
import { OrderV2 } from "@/types/inventoryV2";

export interface RequirementDetailType extends RequirementItem {
  purchaseDesc: string;
  ertDate: string;
  outCount: string;
  checked?: boolean;
}

interface UseGetRetailProps {
  id: string;
  number: string;
  showDel: boolean;
}

type UseGetDetail = (props: UseGetRetailProps) => [
  Requirement | undefined,
  Array<RequirementDetailType>,
  boolean,
  {
    getSubMaterial: () => Promise<void>,
    setDetail: Dispatch<SetStateAction<Requirement | undefined>>,
    setItems: Dispatch<SetStateAction<RequirementDetailType[]>>,
    setOrders: Dispatch<SetStateAction<Array<OrderV2>>>
  },
  Array<OrderV2>,
]

export const useGetDetail: UseGetDetail = ({ id, number, showDel = false }) => {

  const { fetchDetail, loading } = useDataDetail<Requirement, [string]>({ api: apis.fetch });
  const [detail, setDetail] = useState<Requirement | undefined>(undefined);
  const [items, setItems] = useState<Array<RequirementDetailType>>([]);
  const [orders, setOrders] = useState<Array<OrderV2>>([]);

  const getSubMaterial = async () => {
    try {
      let req = await fetchDetail(id);
      setDetail(req);
      let reItems: Array<RequirementDetailType> = req?.items?.map((item) => ({
        ...item,
        purchaseDesc: number,
        ertDate: req.eps ? dateFormat(dayjs(dayjs(req.eps).subtract(3, 'day').valueOf())) : '',
      }));
      setItems(showDel ? reItems : reItems.filter(it => it.deleted === RequirementItemDelEnum.NORMAL));
    } catch (error) { };

    try {
      let orderList = await inventoryOrders(id);
      setOrders(orderList.body ?? []);
    } catch (error) { }

  }

  return [detail, items, loading, { getSubMaterial, setDetail, setItems, setOrders }, orders]
}
